<template>
    <div class="main" ref="main" v-if="loading === 1">
        <div class="product">
            <div class="productImageDiv">
              <div class="productBadgeDiv" v-if="!$empty(product.badgeInfo) || (!$empty(product.badgeList) && product.badgeList.length > 0)">
                <!-- <img :src="`${product.badgeInfo.imageUrl}`" style="width: 30%; max-width: 100px;" v-if="!$empty(product.badgeInfo.imageUrl)"> -->
                <img :src="`${product.badgeInfo.imageUrl}`"
                      v-if="!$empty(product.badgeInfo) && !$empty(product.badgeInfo.imageUrl) && ($empty(product.badgeList) || product.badgeList.length === 0)" class="badge-image" alt="">
                <img v-if="!$empty(product.badgeList) && product.badgeList.length > 0" :src="product.badgeList[0].imageUrl" class="badge-image" alt="" />
                <img v-if="!$empty(product.badgeList) && product.badgeList.length > 1" :src="product.badgeList[1].imageUrl" class="badge-image badge-image--1" alt="" />
                <img v-if="!$empty(product.badgeList) && product.badgeList.length > 2" :src="product.badgeList[2].imageUrl" class="badge-image badge-image--2" alt="" />
              </div>
              <img :src="product.imageUrl" @error="errorImage" class="productImage" v-if="!$empty(product.imageUrl)">
              <img :src="product.image_url"  @error="errorImage" class="productImage" v-else-if="!$empty(product.image_url)">
              <img :src="product.IMAGE_URL" @error="errorImage" class="productImage" v-else-if="!$empty(product.IMAGE_URL)">
              <img src="@/assets/no_item_image.png" class="productImage" style="object-fit: none;" v-else>
            </div>
            <div class="likeReply">
              <div class="likeDiv" @click="operLike('p')"
              v-if="product.like_list.findIndex(x => x.user_seq === $store.state.userData.USER_SEQ) === -1">
              <div>
                <img src="@/assets/icon_not_like.png" style="width:27px;height:23px;" class="func-icon">
                <!-- <span style="color:#E62B73;font-size:13px;margin-left:5px;">{{setLikeUp(product.like_up)}}</span> -->
              </div>
              <div>
                <span class="icon-like-text">{{product.like_up}}</span><span class="icon-span">좋아요</span>
              </div>
              </div>
              <div class="likeDiv" @click="operLike('m')" v-else>
                <div>
                  <img src="@/assets/icon_like.png" style="width:27px;height:23px;" class="func-icon">
                  <!-- <span style="color:#E62B73;font-size:13px;margin-left:5px;">{{setLikeUp(product.like_up)}}</span> -->
                </div>
                <div>
                  <span class="icon-like-text">{{product.like_up}}</span ><span>좋아요</span>
                </div>
              </div>
              <div class="replyDiv">
                <div style="display:flex;align-item:center;justify-content: center;">
                  <img src="@/assets/comments_icon.png" style="width:35px;height:29px;" class="func-icon" @click="openComment">
                  <span class="icon-span" style="font-size:13px;color:#636363;margin-top:10px;">
                    {{`${ Number(100) >= $store.state.commentList.length ? $store.state.commentList.length : '100+'}`}}
                  </span>
                </div>
                <div>
                  <span class="icon-span">댓글</span>
                </div>
              </div>
              <div class="shareDiv">
                <popper
                  trigger="clickToOpen"
                  visible-arrow: true
                  :options="{
                    placement: 'right-start',
                    modifiers: { offset: { offset: '-150px, -20px' } }
                  }">
                  <div class="tooltip-div">
                    <div class="tooltip-left" @click="copy">
                      <div>
                        <img src="@/assets/icon/icon_copylink.png" alt="" />
                      </div>
                      <div>
                        <span class="tooltip-span">링크복사</span>
                      </div>
                    </div>
                    <div style="width:1px;height:60%;border-right:1px solid #e4e4e4;"></div>
                   <div class="tooltip-right" id="kakaotalk-sharing-btn" @click="linkKakao">
                      <div>
                        <img src="@/assets/icon/icon_kakao.png" alt="" />
                      </div>
                      <div>
                        <span class="tooltip-span">카카오톡</span>
                      </div>
                    </div>
                  </div>
                  <button class="share-btn" slot="reference">
                    <img src="@/assets/icon/icon_share.png" class="func-icon">
                  </button>
                </popper>
                <div>
                  <span class="icon-span" style="color:#EA4E83;">공유</span>
                </div>
              </div>
            </div>
            <div class="productName">
              <span v-if="!$empty(product.name)">{{product.name}}</span>
              <span v-else>{{product.NAME}}</span>
            </div>
            <div :class="{'productName': $store.state.storeSeq === '010_12345857', 'product-standard__contents': $store.state.storeSeq !== '010_12345857'}"
              v-if="!$empty(product.standard) && product.standard !== 'null'">
              <span>{{product.standard}}</span>
            </div>
            <div v-if="$empty(product.app_price) || product.app_price === '' || product.app_price === '0'" class="productName">
              <span class="price" v-if="!$empty(product.sell_price) && product.sell_price > 0">{{numberWithCommas(product.sell_price)}}</span>
              <span class="price" v-else-if="!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0">{{numberWithCommas(product.SELL_PRICE)}}</span>
              <!-- <span class="price" v-else>{{numberWithCommas(product.cost_price)}}</span> -->
              <span style="font-size: 13px;color:#FB8C00;" v-if="((!$empty(product.sell_price) && product.sell_price > 0) || (!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0)) && ($empty(product.currencyUnitType) || product.currencyUnitType === 0)">원</span>
              <span style="font-size: 13px;color:#FB8C00;" v-if="((!$empty(product.sell_price) && product.sell_price > 0) || (!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0)) && product.currencyUnitType === 1">원 ~</span>
              <span style="font-size: 13px;color:#FB8C00;" v-if="((!$empty(product.sell_price) && product.sell_price > 0) || (!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0)) && product.currencyUnitType === 2">원 부터</span>
            </div>
            <div v-else class="productName2">
              <div>
                <div>
                  <div>앱 할인가</div>
                  <span>{{ numberWithCommas(product.app_price) }}</span>
                </div>
                <div @click="moveToApp">
                  <img src="@/assets/btn_app_direct.png">
                </div>
              </div>
              <div>
                <div>
                  <div>전단 할인가</div>
                  <span class="price" v-if="!$empty(product.sell_price) && product.sell_price > 0">{{numberWithCommas(product.sell_price)}}</span>
                  <span class="price" v-else-if="!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0">{{numberWithCommas(product.SELL_PRICE)}}</span>
                </div>
                <div></div>
              </div>
            </div>
            <hr style="margin-bottom:5px;">
            <div class="detailInfo-main">
              <div class="detailInfoTitle">
                <span class="info-icon">i</span>
                <span style="font-size: 18px; font-weight:bold;">&nbsp;상세정보</span>
              </div>
              <div class="detailInfo" style="display:flex;">
                <div style="flex:1;" class="detailInfo-inner">
                  <span style="font-size: 16px; font-weight:bold;color:#636363;">&nbsp;매장명</span>
                </div>
                <div style="flex:2;justify-content:flex-end;" class="detailInfo-inner">
                  <span class="storeInfo">
                    {{$store.state.storeInfo.STORE_NAME}}
                  </span>
                </div>
              </div>
              <div class="detailInfo" style="display:flex;">
                <div style="flex:1;" class="detailInfo-inner">
                  <span style="font-size: 16px; font-weight:bold;color:#636363;">최소주문금액</span>
                </div>
                <div style="flex:1;justify-content:flex-end;" class="detailInfo-inner">
                  <span class="storeInfo">
                    {{numberWithCommas($store.state.storeDeliveryInfo.MIN_PROMO_COST) === '' ? '없음' : numberWithCommas($store.state.storeDeliveryInfo.MIN_PROMO_COST) + ' 원'}}
                  </span>
                </div>
              </div>
              <!-- <div class="detailInfo" style="display:flex;">
                <div class="detailInfo-inner" style="flex: 1;">
                  <span style="font-size: 16px; font-weight:bold;color:#636363;">배달정보</span>
                </div>
                <div style="flex:2;align-items:center;justify-content: flex-end;" class="detailInfo-inner"
                  v-html="deliveryCostFormat($store.state.storeInfo.MIN_PROMO_COST, $store.state.storeInfo.DELIVERY_COST, $store.state.storeInfo.OVER_COST)">
                </div>
              </div> -->
              <div class="detailInfo" style="display:flex;">
                <div style="flex:1;" class="detailInfo-inner">
                  <span style="font-size: 16px; font-weight:bold;color:#636363;">배달가능시간</span>
                </div>
                <div style="flex:1;justify-content:flex-end;" class="detailInfo-inner">
                  <span class="storeInfo">
                    {{`${changeTimeFormat($store.state.storeDeliveryInfo.DELIVERY_START_TIME)} ~ ${changeTimeFormat($store.state.storeDeliveryInfo.DELIVERY_END_TIME)}`}}
                  </span>
                </div>
              </div>
            </div>
        </div>
        <div class="foot-open-btn-open"
        v-if="(deliveryFlag !== 1 && Number($store.state.storeInfo.DELIVERY_FLAG) !== 0) &&
        ((!$empty(product.sell_price) && product.sell_price > 0) || (!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0)) &&
        Number(product.status) === 2 && !isEventWait"
        :class="{'foot-open-btn-close': footFlag === 0}">
           <span class="total-value-text">{{getTotalValue()}}</span>
           <span class="total-value-format-text">원</span>
        </div>
        <!-- <div class="foot-onlyOffline" v-else>
          해당 매장은 오프라인 전용 매장입니다.
        </div> -->
        <div class="orderQty" v-if="deliveryFlag !== 0 && Number($store.state.storeInfo.DELIVERY_FLAG) === 1 && Number(product.status) === 2">
          <!-- <span class="closeOrderQty" @click="unsetDelivery">×</span> -->
          <div style="flex:4;display:flex;align-items:center;justify-content: center;">
            <button type="button" class="quantityBtn" @click="changeQuantity('m')">-</button>
            <input type="number" class="quantityInput" :value="product.order_qty" readonly/>
            <button type="button" class="quantityBtn" @click="changeQuantity('p')">+</button>
          </div>
          <div style="flex:4;">
            <span style="color:#2D2D2D;">합계:</span>
            <span style="color:#F67E27;">{{getTotalValue() + '원'}}</span>
          </div>
          <div style="flex:1;">
            <img src="@/assets/btn_delete.png" class="closeOrderQty" @click="unsetDelivery">
          </div>
        </div>
        <div class="foot-menu"
        v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 1 &&
        ((!$empty(product.sell_price) && product.sell_price > 0) || (!$empty(product.SELL_PRICE) && product.SELL_PRICE > 0)) &&
        Number(product.status) === 2 && !isEventWait">
          <div class="foot-left">
              <button type="button" class="quantityBtn" @click="changeQuantity('m')">-</button>
              <input type="number" class="quantityInput" :value="product.order_qty" readonly/>
              <button type="button" class="quantityBtn" @click="changeQuantity('p')">+</button>
          </div>
          <div class="foot-right">
            <button v-if="!checkPacking()" class="basketBtn" @click="handleAddCart(product)">장바구니</button>
            <button v-else class="basketBtn" @click="handleAddCart(product)">포장주문</button>
          </div>
        </div>
        <div class="foot-menu"
        v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0">
          <div class="foot-left">
              <button type="button" class="quantityBtn" @click="changeQuantity('m')">-</button>
              <input type="number" class="quantityInput" :value="product.order_qty" readonly/>
              <button type="button" class="quantityBtn" @click="changeQuantity('p')">+</button>
          </div>
          <div class="foot-right">
            <button class="basketBtn" @click="handleAddCart(product)" style="background-color: #E52B72;">
              <img src="@/assets/icon/icon_wish.svg" style="vertical-align: middle;"/>
              <span style="vertical-align: middle;">&nbsp;찜</span>
            </button>
          </div>
        </div>
        <modal name="commentList" :width="'99%'" :height="'90%'">
          <div class="cmt-main">
            <div class="cmt-head">
              댓글 리스트
              <span class="closeBtn" @click="$modal.hide('commentList')">×</span>
            </div>
            <div class="cmt-body">
              <div class="cmt-content" v-for="(row, index) in $store.state.commentList" :key="index">
                <div class="cmt-content-top">
                  <img src="@/assets/icon_conner_arrow.png" class="cmt-arrow-img" v-if="row.depth > 0" alt="">
                  <img :src="row.userImageUrl" class="cmt-userImg" alt="">
                  <span>{{row.userName}}</span>
                  <dropdown-menu
                  v-if="!$empty($cookies.get('kakaoLogin'))"
                  @opened="getDropData($event)"
                  direction="right"
                  overlayBgColor="rgba(0,0,0,0)"
                  :closeOnClickOutside="true"
                  class="cmt-dropdown-div">
                    <button slot="trigger" class="cmt-overflow-btn">
                      <img class="cmt-overflow-img" src="@/assets/btn_overflow.png" alt="">
                    </button>
                    <ul slot="body">
                      <li v-if="row.userSeq === $store.state.userData.USER_SEQ" @click="updateDeleteReply(row, 0)">삭제</li>
                      <li v-if="row.userSeq === $store.state.userData.USER_SEQ" @click="openModify(row)">수정</li>
                      <li v-if="row.depth === 0" @click="openNestedReply(row, 1)">댓글</li>
                    </ul>
                  </dropdown-menu>
                </div>
                <div :class="[row.depth > 0 ? 'cmt-content-bot-depth' : 'cmt-content-bot']">
                  <div class="bot-left">
                    <!-- {{row.memo}} -->
                    <p style="text-align:left;">
                      {{row.memo}}
                    </p>
                    <!-- <textarea class="memo-area" v-model="row.memo" readonly></textarea> -->
                  </div>
                  <div class="bot-right">
                    {{setTimeFormat(row.regDate)}}
                  </div>
                </div>
                <div class="nested-reply-div" v-if="row.depth === 0 && row.replyFlag === 1">
                  <textarea class="cmt-insert-new"
                  v-model="row.replyContents"
                  placeholder="댓글을 작성해보세요"></textarea>
                  <button class="btn-insert-new" style="background:#d3d3d3;" @click="openNestedReply(row, 0)">취소</button>
                  <button class="btn-insert-new" @click="insertNestedReply(row)">등록</button>
                </div>
              </div>
            </div>
            <div class="cmt-foot">
              <textarea class="cmt-insert-new"
              v-model="newComment"
              v-if="!$empty($cookies.get('kakaoLogin'))"
              placeholder="댓글을 작성해보세요"></textarea>
              <textarea class="cmt-insert-new"
              v-model="newComment"
              v-else
              readonly
              placeholder="로그인 후 이용 가능합니다"></textarea>
              <button class="btn-insert-new" @click="insertNewReply">등록</button>
            </div>
          </div>
        </modal>
        <modal name="minPromo" :width="'99%'" :height="200">
          <div class="inBasketMain">
            <div class="inBasketTitle">
              <h2 style="margin:0;">무료배달가능금액 부족</h2>
            </div>
            <div class="inBasketContent">
              <span>
                배송료가 추가됩니다.
              </span>
            </div>
            <div class="inBasketContent" style="margin-bottom:20px;">
              <span>
                계속 진행하시겠습니까?
              </span>
            </div>
            <div class="inBasketFoot">
              <span class="inBasketBtn" @click="$modal.hide('minPromo')">아니요</span>
              &emsp;
              <span class="inBasketBtn" @click="exeDelivery">네</span>
            </div>
          </div>
        </modal>
        <modal name="alertMinPromo" :width="'99%'" :height="170">
          <div class="inBasketMain">
            <div class="inBasketTitle" style="text-align:center;">
              <h2 style="margin:0;">무료배달가능금액 부족</h2>
            </div>
            <div class="inBasketContent">
              <span>
                최소배달금액을 채워주세요
              </span>
            </div>
            <div class="inBasketFoot">
              <span class="inBasketBtn" @click="$modal.hide('alertMinPromo')">확인</span>
            </div>
          </div>
        </modal>
        <modal name="modifyReply" :width="'99%'" :height="300">
          <div class="modify-main">
            <div class="modify-head">
              댓글 수정
              <span class="closeBtn"
              style="top: 0px; right: 0px;"
              @click="$modal.hide('modifyReply')">×</span>
            </div>
            <div class="modify-body">
              <textarea class="modify-input" v-model="modifyData.memo"></textarea>
            </div>
            <div class="modify-foot">
              <button class="modify-btn" @click="updateDeleteReply(modifyData, 1)">
                저장
              </button>
            </div>
          </div>
        </modal>
        <modal name="addCart" class="add-cart-modal" :width="291" :height="211" @before-open="beforeOpen">
          <div class="flex flex-column add-cart-container justify-space-between">
            <div class="counter__contents">
              <button type="button" class="button minus" @click="selectedItems.order_qty > 0 ? selectedItems.order_qty-- : 0"><i class="fas fa-minus"></i></button>
              <div class="counter-value">{{ selectedItems.order_qty}}</div>
              <button type="button" class="button plus" @click="selectedItems.order_qty++"><i class="fas fa-plus"></i></button>
            </div>
            <div class="button__contents">
              <button type="button" class="counter-save-button" @click="inBasket(selectedItems)">확인</button>
            </div>
          </div>
        </modal>
        <Share v-if="showShareComponent" :clipboardText="clipboardText" @closeShareComponent="closeShareComponent"/>
    </div>
</template>
<script>
import { Hooper, Slide } from 'hooper'
import axios from 'axios'
// import { loginWithKakao } from '@/components/publicFunc/public'
import * as queries from '@/graphql/queries'
import * as mutation from '@/graphql/mutations'
import * as subscribe from '@/graphql/subscriptions'
import { API, graphqlOperation } from 'aws-amplify'
import 'hooper/dist/hooper.css'
import Share from '@/components/shareComponent'
import { searchProductWithKey } from '@/js/http.js'
// import PopperVue from '@soldeplata/popper-vue'
import Popper from 'vue-popperjs'
import 'vue-popperjs/dist/vue-popper.css'
export default {
  name: 'detailProduct',
  components: {
    Hooper,
    Slide,
    Share,
    'popper': Popper
    // PopperVue
  },
  metaInfo () {
    return {
      title: `상세화면 | 스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`,
      meta: [
        {
          vmid: 'title',
          name: 'title',
          content: `${this.product.name} | 스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`
        },
        {
          vmid: 'subject',
          name: 'subject',
          content: `${this.product.name} | ${this.$store.state.storeInfo.STORE_NAME} 행사`
        },
        {
          vmid: 'name',
          name: 'name',
          content: `${this.product.name} | 스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`
        },
        {
          vmid: 'description',
          name: 'description',
          content: `${this.product.name} | ${this.$store.state.storeInfo.STORE_NAME} | 스마트전단 - 마트 행사상품을 모바일로 간편하게 확인 후 주문까지`
        }
      ]
    }
  },
  computed: {
    appFlag: function () {
      return this.$store.state.storeInfo.APP_FLAG
    },
    appUrl: function () {
      return this.$store.state.storeInfo.APP_URL
    }
  },
  data () {
    return {
      product: {},
      commentList: [],
      deliveryFlag: 0,
      loading: 0,
      footFlag: 1,
      newComment: '',
      dropData: '',
      modifyData: {},
      selectedItems: {},
      showShareComponent: false,
      clipboardText: '',
      msg: '동해물과 백두산이',
      show: false,
      options: this.$_.merge(
        {
          placement: 'top',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 20] // separ.ation from reference object
              }
            },
            {
              name: 'arrow',
              options: {
                padding: 10 // 4px from the edges of the popper
              }
            }
          ]
        },
        this.options
      ),
      key: '',
      isEventWait: false,
    }
  },
  async mounted () {
    const vm = this
    console.log('mounted::', this.$options.name)
    if (vm.$empty(vm.$store.state.storeInfo)) {
      await vm.firstFunc()
    }
    this.isEventWait = this.$store.state.selectProduct.isEventWait
    const sharedItem = this.$route.query.detail
    if (sharedItem !== undefined && !this.$empty(sharedItem)) {
      await this.getProduct(sharedItem)
    }
    this.key = this.$route.query.seq
    !vm.$empty(vm.$route.query.eventSeq) && await vm.setKey(vm.$route.query.eventSeq)
    this.setProduct()
    this.updateSubscribe()
    this.createSubscribe()
    setTimeout(() => {
      this.linkKakao()
    }, 1000)
  },
  filters: {
    numberOfDigits: val => {
      return val === null ? 0 : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    firstFunc () { // 매장정보 가져오기 (매장사진등)
      const vm = this
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: `${process.env.API}/getStoreInfo/store/${vm.$route.query.seq}`
        })
          .then((response) => {
            vm.storeInfo = vm.$_.cloneDeep(response.data[0])
            vm.$store.state.storeInfo = vm.$_.cloneDeep(response.data[0])
            vm.$cookies.set('storeInfo', vm.$store.state.storeInfo)
            if (response.data[0].STORE_LOGO.indexOf(',') !== -1) {
              if (response.data[0].STORE_LOGO.indexOf('sery-images') !== -1) {
                var url = response.data[0].STORE_LOGO.split(',')
                vm.storeImage = `${process.env.imgUrl}/store/${url[1]}`
                resolve('success1')
              } else {
                vm.transStoreLogo(response.data[0].STORE_LOGO)
                resolve('success1')
              }
            } else {
              vm.storeImage = response.data[0].STORE_LOGO
              resolve('success1')
            }
          })
      })
    },
    setKey (eventSeq) {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.key = `${vm.$route.query.seq}_${eventSeq}`
        resolve('success')
      })
    },
    showPopper () {
      this.$nextTick(() => {
        this.show = !this.show
        window.scrollTo(0, 2)
      })
      // alert('준비중입니다.')
    },
    copy () {
      const vm = this
      let params = ''
      if (!vm.$empty(vm.$route.query.eventSeq)) {
        params = `seq=${vm.$route.query.seq}&eventSeq=${vm.$route.query.eventSeq}&detail=${vm.product.barcode}`
      } else if (!vm.$empty(vm.$store.state.eventSeq)) {
        params = `seq=${vm.$route.query.seq}&eventSeq=${vm.$store.state.eventSeq}&detail=${vm.product.barcode}`
      } else {
        params = `seq=${vm.$route.query.seq}&detail=${vm.product.barcode}`
      }
      vm.clipboardText = `${window.location.origin}/detailProduct?${params}`
      const textarea = document.createElement('textarea')
      textarea.value = vm.clipboardText
      document.body.appendChild(textarea)
      textarea.select()
      textarea.setSelectionRange(0, 9999)
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$gtag.event('테리문자_공유_링크복사', {
        event_category: this.$route.query.seq,
        event_label: vm.clipboardText,
        value: ''
      })
      alert('복사되었습니다.')
    },
    linkKakao () {
      const vm = this
      let imageUrl = ''
      let product = this.product
      if (!this.$empty(product.imageUrl)) {
        imageUrl = this.changeUrl(product, 'imageUrl')
      } else if (!this.$empty(product.image_url)) {
        imageUrl = this.changeUrl(product, 'image_url')
      } else {
        imageUrl = this.changeUrl(product, 'IMAGE_URL')
      }
      console.log('imageUrl :::::', imageUrl)
      let params = ''
      if (!vm.$empty(vm.$route.query.eventSeq)) {
        params = `seq=${vm.$route.query.seq}&eventSeq=${vm.$route.query.eventSeq}&detail=${vm.product.barcode}`
      } else if (!vm.$empty(vm.$store.state.eventSeq)) {
        params = `seq=${vm.$route.query.seq}&eventSeq=${vm.$store.state.eventSeq}&detail=${vm.product.barcode}`
      } else {
        params = `seq=${vm.$route.query.seq}&detail=${vm.product.barcode}`
      }
      vm.clipboardText = `${window.location.origin}/detailProduct?${params}`
      console.log('link :::::', vm.clipboardText)
      this.$gtag.event('테리문자_공유_카카오톡', {
        event_category: this.$route.query.seq,
        event_label: vm.clipboardText,
        value: ''
      })
      window.Kakao.Share.createDefaultButton({
        container: '#kakaotalk-sharing-btn',
        objectType: 'feed',
        content: {
          title: '행사할 땐 세리해요!',
          description: `상품명: ${!vm.$empty(vm.product.name) ? vm.product.name : vm.product.NAME}
행사가: ${!vm.$empty(vm.product.sell_price) ? vm.numberWithCommas(vm.product.sell_price) : vm.numberWithCommas(vm.product.SELL_PRICE)}`,
          imageUrl: imageUrl,
          link: {
            mobileWebUrl: vm.clipboardText,
            webUrl: vm.clipboardText
          }
        },
        buttons: [
          {
            title: '상품 보기',
            link: {
              // mobileWebUrl: vm.appFlag === '1' ? vm.appUrl : 'https://tery.page.link/install',
              // webUrl: vm.appFlag === '1' ? vm.appUrl : 'https://tery.page.link/install'
              mobileWebUrl: vm.clipboardText,
              webUrl: vm.clipboardText
            }
          }
        ]
        // social: {
        //   likeCount: 9999,
        //   commentCount: 9999,
        //   sharedCount: 30,
        // },
      })
    },
    hidePopper () {
      this.show = false
    },
    changeUrl (obj, type) {
      if (obj[type].indexOf('sery-images/store') > -1) {
        const keyArr = obj[type].split(',')
        return `https://d2nic58uh63efu.cloudfront.net/store/${keyArr[1]}`
      } else {
        return obj[type]
      }
    },
    async getProduct (data) {
      const { seq, detail } = this.$route.query
      try {
        const result = await searchProductWithKey(`${detail}_${seq}`)
        console.log('getProduct :::::', result)
        result._source.order_qty = 0
        if (result._source.like_list === undefined) {
          result._source.like_list = []
          result._source.like_up = 0
        }
        this.$store.state.selectProduct = result._source
      } catch (error) {
        console.log(error)
      }
    },
    closeShareComponent () {
      this.showShareComponent = false
    },
    productShare (item) {
      console.log(item)
      const vm = this
      vm.showShareComponent = true
      let params = ''
      if (!vm.$empty(vm.$route.query.eventSeq)) {
        params = `seq=${vm.$store.state.storeSeq}&eventSeq=${vm.$route.query.eventSeq}&detail=${item.barcode}`
      } else if (!vm.$empty(vm.$store.state.eventSeq)) {
        params = `seq=${vm.$store.state.storeSeq}&eventSeq=${vm.$store.state.eventSeq}&detail=${item.barcode}`
      } else {
        params = `seq=${vm.$store.state.storeSeq}&detail=${item.barcode}`
      }
      vm.clipboardText = `${window.location.origin}/detailProduct?${params}`
      alert('복사되었습니다')
    },
    handleAddCart (data) {
      // const vm = this
      data.isAddCart = true
      // vm.$modal.show('addCart', {data: data})
      this.inBasket(data)
    },
    beforeOpen (obj) {
      this.selectedItems = obj.params.data
    },
    async setProduct () {
      const vm = this
      if (!vm.$empty(vm.$store.state.selectProduct)) {
        this.$cookies.set('product', vm.$store.state.selectProduct)
      }
      var first = await firstFunc()
      console.log('detail first:::', first)
      var second = await API.graphql(
        graphqlOperation(queries.queryStoreProductComment, {
          storeSeq: vm.product.store_seq,
          storeProductSeq: `${vm.product.barcode}_${vm.product.store_seq}`
        })
      )
      var item = second.data.queryStoreProductComment.items
      var head = vm.$_.filter(item, {'depth': 0})
      var tail = vm.$_.filter(item, {'depth': 1})
      // this.commentList = await divisionCommnet(head, tail)
      this.$store.commit('cloneComment', await divisionCommnet(head, tail))
      function firstFunc () { // 상품 vm.product 로 이동
        return new Promise(async (resolve, reject) => {
          vm.product = !vm.$empty(vm.$store.state.selectProduct) ? vm.$_.cloneDeep(vm.$store.state.selectProduct) : vm.$cookies.get('product')
          if (!vm.$empty(vm.product.event_list) && vm.product.event_list.length > 0) {
            if (!vm.$empty(vm.$route.query.eventSeq) || !vm.$empty(vm.$store.state.eventSeq)) {
              // 행사가격 표시
              if (vm.$empty(vm.$store.state.batchSeq)) {
                const result = await vm.$axios.get(`${process.env.API}/smart-view-event/${vm.$route.query.seq}/${vm.$route.query.eventSeq}`)
                const { batchSeq } = result.data.data.event
                vm.$store.state.batchSeq = batchSeq
              }
              let index = vm.product.event_list.findIndex(x => x.batch_seq === vm.$store.state.batchSeq)
              if (index > -1) {
                vm.product.batchSeq = vm.$store.state.batchSeq
                vm.product.cost_price = vm.product.event_list[index].cost_price
                vm.product.sell_price = vm.product.event_list[index].sell_price
                vm.product.app_price = vm.product.event_list[index].app_price
                vm.product.image_url = vm.product.event_list[index].image_url
                if (!vm.$empty(vm.product.event_list[index].badge_info)) {
                  vm.product.badgeInfo = vm.product.event_list[index].badge_info
                }
                if (!vm.$empty(vm.product.event_list[index].badge_list)) {
                  vm.product.badgeList = vm.product.event_list[index].badge_list
                }
                if (!vm.$empty(vm.product.event_list[index].currencyUnitType)) {
                  vm.product.currencyUnitType = vm.product.event_list[index].currencyUnitType
                }
              }
            } else {
              // 행사가 아닌 경우
              const nowDate = vm.$dayjs().format('YYYYMMDD')
              let index = vm.product.event_list.findIndex(x => vm.$dayjs(x.start_date).format('YYYYMMDD') <= nowDate && nowDate <= vm.$dayjs(x.end_date).format('YYYYMMDD'))
              if (index > -1) {
                vm.product.cost_price = vm.product.event_list[index].cost_price
                vm.product.sell_price = vm.product.event_list[index].sell_price
                vm.product.app_price = vm.product.event_list[index].app_price
                vm.product.image_url = vm.product.event_list[index].image_url
                if (!vm.$empty(vm.product.event_list[index].badge_info)) {
                  vm.product.badgeInfo = vm.product.event_list[index].badge_info
                }
                if (!vm.$empty(vm.product.event_list[index].badge_list)) {
                  vm.product.badgeList = vm.product.event_list[index].badge_list
                }
              }
            }
          }
          vm.product.order_qty = 0
          resolve('success1')
        })
      }
      function divisionCommnet (head, tail) { // 댓글 분류
        return new Promise((resolve, reject) => {
          var result = []
          head = vm.$_.orderBy(head, ['regDate'], ['desc'])
          for (let i = 0; i < head.length; i++) {
            var data = head[i]
            data.replyFlag = 0
            data.replyContents = ''
            result.push(data)
            var searchTail = vm.$_.orderBy(vm.$_.filter(tail, {'commentHead': data.regDate}), ['regDate'], ['asc'])
            result.push(...searchTail)
          }
          vm.loading = 1
          resolve(result)
        })
      }
    },
    changeFootFlag () {
      if (this.footFlag === 1) {
        this.footFlag = 0
      } else {
        this.footFlag = 1
      }
    },
    openComment () {
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        this.$modal.show('commentList')
      } else {
        alert('테리앱으로 이동합니다.')
        this.moveToApp()
        // loginWithKakao()
      }
    },
    openModify (data) {
      this.modifyData = this.$_.cloneDeep(data)
      this.$modal.show('modifyReply')
    },
    async inBasket (val) { // 장바구니 넣기
      const vm = this
      console.log('key :::::', vm.key)
      vm.$modal.hide('addCart')
      if (val.order_qty < 1) {
        vm.removeBasketItem(val)
        val.isAddCart = false
        return
      }
      val.isAddCart = true
      if (vm.$empty(localStorage.getItem(vm.key))) {
        // 장바구니가 비었을때
        var data1 = []
        if (!vm.$empty(val.store_seq)) {
          val.storeSeq = val.store_seq
          console.log('product:::', val)
        }
        data1.push(val)
        localStorage.setItem(vm.key, JSON.stringify(data1))
        vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
      } else {
        // 장바구니가 비지 않았을때
        console.log('장바구니가 안빔')
        var data2 = localStorage.getItem(vm.key)
        data2 = JSON.parse(data2)
        if (!vm.$empty(val.store_seq)) {
          val.storeSeq = val.store_seq
        }
        var barcodeIndex = data2.findIndex(x => x.barcode === val.barcode)
        // 장바구니 담은 상품이 이미 담겨 있을때 (중복상품)
        if (barcodeIndex !== -1) {
          data2[barcodeIndex].order_qty = val.order_qty
          // vm.addCart.totalPrice += val.sell_price * data2[barcodeIndex].order_qty
          localStorage.setItem(vm.key, JSON.stringify(data2))
          vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
        } else {
          data2.push(val)
          localStorage.setItem(vm.key, JSON.stringify(data2))
          vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
        }
      }
      await vm.$nextTick()
      // vm.calcTotalPrice()
      setTimeout(() => {
        vm.$store.state.inBasket = true
      }, 200)
      setTimeout(() => {
        vm.$store.state.inBasket = false
      }, 700)
      // const vm = this
      // console.log(val)
      // vm.$modal.hide('addCart')
      // if (vm.$empty(localStorage.getItem(vm.key))) {
      //   // 장바구니가 비었을때
      //   var data1 = []
      //   if (!vm.$empty(vm.product.store_seq)) {
      //     vm.product.storeSeq = vm.product.store_seq
      //     vm.product.order_qty = val.order_qty
      //     console.log('product:::', vm.product)
      //   }
      //   data1.push(vm.product)
      //   localStorage.setItem(vm.key, JSON.stringify(data1))
      //   vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
      //   console.log('상품을 장바구니에 담았습니다.')
      //   vm.$store.state.inBasket = true
      //   setTimeout(() => {
      //     vm.$store.state.inBasket = false
      //   }, 400)
      // } else {
      //   // 장바구니가 비지 않았을때
      //   console.log('장바구니가 안빔')
      //   var data2 = localStorage.getItem(vm.key)
      //   data2 = JSON.parse(data2)
      //   if (!vm.$empty(vm.product.store_seq)) {
      //     vm.product.storeSeq = vm.product.store_seq
      //   }
      //   var barcodeIndex = data2.findIndex(x => x.barcode === vm.product.barcode)
      //   // 장바구니 담은 상품이 이미 담겨 있을때 (중복상품)
      //   if (barcodeIndex !== -1) {
      //     data2[barcodeIndex].order_qty = val.order_qty
      //     localStorage.setItem(vm.key, JSON.stringify(data2))
      //     vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
      //     console.log('상품을 장바구니에 담았습니다.')
      //     vm.$store.state.inBasket = true
      //     setTimeout(() => {
      //       vm.$store.state.inBasket = false
      //     }, 400)
      //   } else {
      //     data2.push(vm.product)
      //     localStorage.setItem(vm.key, JSON.stringify(data2))
      //     vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key))
      //     console.log('상품을 장바구니에 담았습니다.')
      //     vm.$store.state.inBasket = true
      //     setTimeout(() => {
      //       vm.$store.state.inBasket = false
      //     }, 400)
      //   }
      // }
    },
    changeQuantity (oper) {
      var data = this.$_.cloneDeep(this.product)
      if (oper === 'p') {
        data.order_qty += 1
        this.product = this.$_.cloneDeep(data)
      } else {
        if (data.order_qty >= 2) {
          data.order_qty -= 1
          this.product = this.$_.cloneDeep(data)
        } else {
          console.log('최소수량')
        }
      }
    },
    setTimeFormat (time) {
      var now = this.$dayjs()
      var regDate = this.$dayjs(time)
      var result = ''
      if (now.diff(regDate, 'day') !== 0) {
        result = `${now.diff(regDate, 'day')}일전`
        return result
      } else if (now.diff(regDate, 'day') === 0 && now.diff(regDate, 'hour') !== 0) {
        result = `${now.diff(regDate, 'hour')}시간전`
        return result
      } else {
        if (now.diff(regDate, 'minute') < 11) {
          result = '방금전'
          return result
        } else {
          result = `${now.diff(regDate, 'minute')}분전`
          return result
        }
      }
    },
    unsetDelivery () {
      this.product.order_qty = 1
      this.deliveryFlag = 0
    },
    setDelivery () {
      var deliveryInfo = this.$store.state.storeDeliveryInfo
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        if (this.deliveryFlag !== 1) {
          this.product.order_qty = 1
          this.deliveryFlag = 1
        } else {
          var total = !this.$empty(this.product.sell_price) ? this.product.sell_price * this.product.order_qty : this.product.SELL_PRICE * this.product.order_qty
          if ((deliveryInfo.MIN_PROMO_COST > total) ||
          (deliveryInfo.MIN_PROMO_COST > 0 && deliveryInfo.DELIVERY_COST === 0)) {
            this.$modal.show('alertMinPromo')
          } else {
            console.log('prePay로 넘어감')
            this.exeDelivery()
          }
        }
      } else {
        // loginWithKakao()
        this.moveToApp()
      }
    },
    getDropData (value) {
      this.dropData = value
      this.dropData.isOpen = true
      console.log('data:::', this.dropData)
    },
    exeDelivery () {
      var tmpArr = []
      tmpArr.push(this.product)
      this.$store.state.prePay = this.$_.cloneDeep(tmpArr)
      var index = this.$store.state.storeSeqList.findIndex(x => x === this.product.store_seq)
      if (index === -1) {
        this.$store.state.storeSeqList.push(this.product.store_seq)
        this.$router.push('prePay')
      } else {
        this.$router.push('prePay')
      }
    },
    openNestedReply (data, type) {
      console.log('pre:::', this.dropData)
      this.dropData.isOpen = false
      console.log('post:::', this.dropData)
      if (type === 1) {
        data.replyContents = ''
        data.replyFlag = 1
      } else {
        data.replyContents = ''
        data.replyFlag = 0
      }
    },
    async updateDeleteReply (data, type) {
      // const vm = this
      if (type === 0) {
        var preDelete = confirm('삭제하시겠습니까?')
        if (preDelete) {
          var setData = await firstFunc(data, type)
          var deleteComment = await API.graphql(
            graphqlOperation(mutation.updateStoreProductComment, {
              input: setData
            })
          )
          console.log('updateStoreProductComment:::', deleteComment)
          this.dropData.isOpen = false
        } else {
        }
      } else {
        console.log('modify:::', data)
        delete data.replyFlag
        delete data.replyContents
        var updateComment = await API.graphql(
          graphqlOperation(mutation.updateStoreProductComment, {
            input: data
          })
        )
        console.log('updateComment:::', updateComment)
        this.modifyData = {}
        this.$modal.hide('modifyReply')
      }
      function firstFunc (data, type) {
        return new Promise((resolve, reject) => {
          data.memo = '삭제된 댓글 입니다.'
          delete data.replyFlag
          delete data.replyContents
          resolve(data)
        })
      }
    },
    async insertNewReply () {
      const vm = this
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        var setData = await firstFunc(vm.product)
        console.log('setData:::', setData)
        var insertComment = await API.graphql(
          graphqlOperation(mutation.createStoreProductComment, {
            input: setData
          })
        )
        console.log('insertNewReply:::', insertComment)
        this.newComment = ''
        document.getElementsByClassName('cmt-body')[0].scrollTop = 0
      } else {
        alert('로그인 후 이용 가능합니다.')
      }
      function firstFunc (data) {
        return new Promise((resolve, reject) => {
          var userImage = ''
          var userData = vm.$store.state.userData
          if (userData.PROFILE_URL.indexOf(',') !== -1) {
            if (userData.PROFILE_URL.indexOf('sery-images') !== -1) {
              var url = userData.PROFILE_URL.split(',')
              userImage = `${process.env.imgUrl}/user/${url[1]}`
            } else {
              userImage = vm.transStoreLogo(userData.PROFILE_URL)
            }
          } else {
            userImage = userData.PROFILE_URL
          }
          var obj = {
            storeProductSeq: `${data.barcode}_${data.store_seq}`,
            regDate: vm.$dayjs().format('YYYYMMDDHHmmssSSS'),
            userSeq: userData.USER_SEQ,
            userImageUrl: userImage,
            userName: userData.USER_NAME,
            storeSeq: data.store_seq,
            depth: 0,
            memo: vm.newComment,
            commentType: 0,
            commentHead: ''
          }
          resolve(obj)
        })
      }
    },
    async insertNestedReply (data) {
      const vm = this
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        var setData = await firstFunc(data)
        var insertComment = await API.graphql(
          graphqlOperation(mutation.createStoreProductComment, {
            input: setData
          })
        )
        console.log('insertNestedReply:::', insertComment)
      } else {
        alert('로그인 후 이용 가능합니다.')
      }
      function firstFunc (data) {
        return new Promise((resolve, reject) => {
          var userImage = ''
          var userData = vm.$store.state.userData
          if (userData.PROFILE_URL.indexOf(',') !== -1) {
            if (userData.PROFILE_URL.indexOf('sery-images') !== -1) {
              var url = userData.PROFILE_URL.split(',')
              userImage = `${process.env.imgUrl}/user/${url[1]}`
            } else {
              userImage = vm.transStoreLogo(userData.PROFILE_URL)
            }
          } else {
            userImage = userData.PROFILE_URL
          }
          var obj = {
            storeProductSeq: data.storeProductSeq,
            regDate: vm.$dayjs().format('YYYYMMDDHHmmssSSS'),
            userSeq: userData.USER_SEQ,
            userImageUrl: userImage,
            userName: userData.USER_NAME,
            storeSeq: data.storeSeq,
            depth: 1,
            memo: data.replyContents,
            commentType: 0,
            commentHead: data.regDate
          }
          resolve(obj)
        })
      }
    },
    transStoreLogo (val) {
      var file = val.split(',')
      axios({
        method: 'get',
        url: 'https://image.sery.co.kr',
        params: {
          bucketName: file[0],
          fileName: file[1]
        }
      })
        .then((response) => {
          if (response.data.result === 'success') {
            return response.data.url
          }
        })
    },
    async updateSubscribe () {
      const vm = this
      vm.subscription = await API.graphql({
        query: subscribe.onUpdateStoreProductComment,
        variables: {
          storeProductSeq: `${vm.product.barcode}_${vm.product.store_seq}`
        }
      }).subscribe({
        next: async (response) => {
          var commentList = vm.$store.state.commentList
          var newData = response.value.data.onUpdateStoreProductComment
          this.$store.commit('updateComment', newData)
          var head = vm.$_.filter(commentList, {'depth': 0})
          var tail = vm.$_.filter(commentList, {'depth': 1})
          // vm.commentList = vm.$_.uniqBy(await divisionCommnet(head, tail), 'regDate')
          vm.$store.commit('cloneComment', vm.$_.uniqBy(await divisionCommnet(head, tail), 'regDate'))
        }
      })
      function divisionCommnet (head, tail) { // 댓글 분류
        return new Promise((resolve, reject) => {
          var result = []
          head = vm.$_.orderBy(head, ['regDate'], ['desc'])
          for (let i = 0; i < head.length; i++) {
            var data = head[i]
            data.replyFlag = 0
            data.replyContents = ''
            result.push(data)
            var searchTail = vm.$_.orderBy(vm.$_.filter(tail, {'commentHead': data.regDate}), ['regDate'], ['asc'])
            result.push(...searchTail)
          }
          vm.loading = 1
          resolve(result)
        })
      }
    },
    async createSubscribe () {
      const vm = this
      vm.subscription = await API.graphql({
        query: subscribe.onCreateStoreProductComment,
        variables: {
          storeProductSeq: `${vm.product.barcode}_${vm.product.store_seq}`
        }
      }).subscribe({
        next: async (response) => {
          var commentList = vm.$store.state.commentList
          vm.$store.commit('pushComment', response.value.data.onCreateStoreProductComment)
          var head = vm.$_.filter(commentList, {'depth': 0})
          var tail = vm.$_.filter(commentList, {'depth': 1})
          // vm.commentList = vm.$_.uniqBy(await divisionCommnet(head, tail), 'regDate')
          vm.$store.commit('cloneComment', vm.$_.uniqBy(await divisionCommnet(head, tail), 'regDate'))
        }
      })
      function divisionCommnet (head, tail) { // 댓글 분류
        return new Promise((resolve, reject) => {
          var result = []
          head = vm.$_.orderBy(head, ['regDate'], ['desc'])
          for (let i = 0; i < head.length; i++) {
            var data = head[i]
            data.replyFlag = 0
            data.replyContents = ''
            result.push(data)
            var searchTail = vm.$_.orderBy(vm.$_.filter(tail, {'commentHead': data.regDate}), ['regDate'], ['asc'])
            result.push(...searchTail)
          }
          vm.loading = 1
          resolve(result)
        })
      }
    },
    numberWithCommas (x) {
      if (!this.$empty(x)) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return '0'
      }
    },
    changeTimeFormat (val) {
      var result = ''
      if (!this.$empty(val)) {
        result = `${val.substr(0, 2)}:${val.substr(2, 2)}`
        return result
      } else {
        return result
      }
    },
    getTotalValue () {
      var result = 0
      var data = this.product
      result = !this.$empty(data.sell_price) ? data.sell_price * data.order_qty : data.SELL_PRICE * data.order_qty
      return this.numberWithCommas(result)
    },
    setLikeUp (val) {
      var result = ''
      if (val < 100) {
        result = val
        return result
      } else {
        result = '100+'
        return result
      }
    },
    async operLike (oper) {
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        this.loading = 0
        var nowTime = this.$dayjs().unix()
        var list = await changeLikeList(oper, nowTime, this.product, this.$store.state.userData)
        var cnt = await calcLikeCnt(oper, this.product)
        // var refresh = await refreshProduct(this.product)
        console.log('list:::', list)
        console.log('cnt:::', cnt)
        if (oper === 'p') {
          this.product.like_up += 1
          var userData = {
            time: this.$dayjs(nowTime).format('YYYYMMDDHHmmss'),
            user_seq: this.$store.state.userData.USER_SEQ
          }
          this.product.like_list.push(userData)
        } else {
          this.product.like_up -= 1
          var index = this.product.like_list.findIndex(x => x.user_seq === this.$store.state.userData.USER_SEQ)
          if (index !== -1) {
            this.product.like_list.splice(index, 1)
          }
        }
      } else {
        alert('테리앱으로 이동합니다.')
        this.moveToApp()
        // loginWithKakao()
      }
      this.loading = 1
      function changeLikeList (oper, nowTime, product, userData) {
        return new Promise((resolve, reject) => {
          var query = {}
          if (oper === 'p') {
            query = {
              script: {
                source: `if (ctx._source.like_list != null) {def targets = ctx._source.like_list.findAll(like -> like.user_seq == params.data.user_seq); if (targets.size() > 0) {for (like in targets) {like.time = params.data.time}} else {ctx._source.like_list.add(params.data)}} else {ctx._source.like_list = []; ctx._source.like_list.add(params.data)}`,
                params: {
                  data: {
                    user_seq: userData.USER_SEQ,
                    time: nowTime
                  }
                },
                lang: `painless`
              }
            }
          } else {
            query = {
              script: {
                source: `if (ctx._source.like_list != null) {ctx._source.like_list.removeIf(like -> like.user_seq == params.data.user_seq)}`,
                params: {
                  data: {
                    user_seq: userData.USER_SEQ
                  }
                },
                lang: `painless`
              }
            }
          }
          axios({
            method: 'post',
            headers: {
              'content-type': 'application/json',
              'Authorization': 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ='
            },
            url: `https://es.sery.co.kr/product/_update/${product.barcode}_${product.store_seq}`,
            data: JSON.stringify(query)
          })
            .then((response) => {
              resolve('success1')
            })
        })
      }
      function calcLikeCnt (oper, product) {
        return new Promise((resolve, reject) => {
          var query = {}
          if (oper === 'p') {
            query = {
              script: {
                source: `if (ctx._source.like_up != null) {ctx._source.like_up++} else {ctx._source.like_up = 1}`,
                lang: `painless`
              }
            }
          } else {
            query = {
              script: {
                source: `if (ctx._source.like_up != null && ctx._source.like_up > 0) {ctx._source.like_up--} else {ctx._source.like_up = 0}`,
                lang: `painless`
              }
            }
          }
          axios({
            method: 'post',
            headers: {
              'content-type': 'application/json',
              'Authorization': 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ='
            },
            url: `https://es.sery.co.kr/product/_update/${product.barcode}_${product.store_seq}`,
            data: JSON.stringify(query)
          })
            .then((response) => {
              resolve('success2')
            })
        })
      }
    },
    checkPacking () {
      const vm = this
      const storeDeliveryInfo = vm.$store.state.storeDeliveryInfo
      if (!vm.$empty(storeDeliveryInfo.result.type0) && !vm.$empty(storeDeliveryInfo.result.type1) && !vm.$empty(storeDeliveryInfo.result.type2) &&
        !vm.$empty(storeDeliveryInfo.result.type3) && !vm.$empty(storeDeliveryInfo.result.type4) &&
        Number(storeDeliveryInfo.result.type0) === 0 && Number(storeDeliveryInfo.result.type1) === 0 && Number(storeDeliveryInfo.result.type2) === 0) {
        return true
      } else {
        return false
      }
    },
    checkBasket () {
      const vm = this
      console.log('checkBasket :::::', vm.key)
      const cartInfo = JSON.parse(localStorage.getItem(vm.key))
      try {
        if (!vm.$empty(cartInfo)) {
          for (let i = 0; i < cartInfo.length; i++) {
            let x = cartInfo[i]
            if (vm.product.barcode === x.barcode) {
              vm.product.order_qty = x.order_qty
            }
          }
        }
      } catch (error) {
        console.log('checkBasket :::::', error)
      }
    }
    // deliveryCostFormat (minPromo, deliveryCost, overCost) {
    //   var result = `<div class="delivery-pre">`
    //   if (minPromo > 0 && deliveryCost <= 0 && overCost === 0) {
    //     result += `최소주문금액 ${this.numberWithCommas(minPromo)}원 이상일때<br/> 무료배달</div>`
    //     return result
    //   } else if (minPromo > 0 && deliveryCost <= 0 && overCost > 0) {
    //     result += `최소주문금액<br/>${this.numberWithCommas(minPromo)}원 미만일때 배달불가<br/> 이상 일때 ${this.numberWithCommas(overCost)}원 배달요금 발생</div>`
    //     return result
    //   } else if (minPromo > 0 && deliveryCost > 0 && overCost > 0) {
    //     result += `최소주문금액 ${this.numberWithCommas(minPromo)}원 미만일때<br/>${this.numberWithCommas(deliveryCost)}원 배달요금 발생\n이상 일때 ${this.numberWithCommas(overCost)}원 배달요금 발생</div>`
    //     return result
    //   } else if (minPromo > 0 && deliveryCost > 0 && overCost === 0) {
    //     result += `최소주문금액 ${this.numberWithCommas(minPromo)}원 미만일때<br/>${this.numberWithCommas(deliveryCost)}원 배달요금 발생\n이상 일때 무료배달</div>`
    //     return result
    //   } else if (minPromo === 0 && overCost > 0) {
    //     result += `배달요금 ${this.numberWithCommas(overCost)} 부과</div>`
    //     return result
    //   } else if (minPromo === 0 && overCost === 0) {
    //     result += `무료배달</div>`
    //     return result
    //   } else {
    //     result += `</div>`
    //     return result
    //   }
    // }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      console.log('beforeRouteEnter :::::', vm.$route.query.detail)
      vm.key = vm.$route.query.seq
      !vm.$empty(vm.$route.query.eventSeq) && await vm.setKey(vm.$route.query.eventSeq)
      if (vm.product.barcode !== vm.$route.query.detail) {
        vm.product.imageUrl = ''
        vm.isEventWait = vm.$store.state.selectProduct.isEventWait
        const sharedItem = vm.$route.query.detail
        if (sharedItem !== undefined && !vm.$empty(sharedItem)) {
          await vm.getProduct(sharedItem)
        }
        vm.setProduct()
        vm.updateSubscribe()
        vm.createSubscribe()
      }
      vm.checkBasket()
    })
  }
}
</script>

<style lang="scss" scoped>
@import url('/css/detailProduct.scss');
div.v-dropdown-menu {
  $this: &;
  $slide-offset: 12px;
  position: relative;
  display: inline-block;
  &__trigger {
    position: relative;
  }
  &__container {
    position: absolute;
    top: 100%;
    bottom: auto;
    min-width: 100px;
    box-sizing: border-box;
    max-width: 100%;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  &--dropup & {
    &__container {
      top: auto;
      bottom: 100%;
    }
  }
  &--direction-left & {
    &__container {
      left: 0;
    }
  }
  &--direction-center & {
    &__container {
      left: 50%;
      transform: translateX(-50%) translateY(0);
    }
  }
  &--direction-right & {
    &__container {
      right: 0;
    }
  }
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  }
  // Default Transition
  .default-enter-active {
    transition: all 0.2s ease;
  }
  .default-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .default-enter,
  .default-leave-to {
    transform: translateY($slide-offset);
    opacity: 0;
  }
  &--mode-hover {
    .default-enter,
    .default-leave-active {
      transition-delay: 0.4s;
    }
  }
  &--dropup {
    .default-enter,
    .default-leave-to {
      transform: translateY(-$slide-offset);
    }
    &#{$this}--direction-center {
      .default-enter,
      .default-leave-to {
        transform: translateX(-50%) translateY(-$slide-offset);
      }
    }
  }
  &--direction-center {
    .default-enter,
    .default-leave-to {
      transform: translateX(-50%) translateY($slide-offset);
    }
  }
}
.badge-image {
  position: relative;
  width: 30%;
  max-width: 100px;
  top: 0;
  left: 10px;
  object-fit: contain;
  &--1 {
    left: -3%;
  }
  &--2 {
    left: -10%;
  }
}
.productName2 {
  background: #ffffff;
  width: 100%;
  height: auto;
  text-align: left;
  font-size: 18px;
  margin: 10px 0px 10px 0px;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  > div:nth-of-type(1) {
    display: flex;
    flex-direction: row;
    font-size: 24px;
    > div:nth-of-type(1) {
      display: flex;
      flex-direction: row;
      width: 50%;
      align-items: center;
      > div {
        width: 60%;
      }

      > span {
        width: 40%;
        color: #FF0000;
        font-weight: 800;
        text-align: end;
      }
    }

    > div:nth-of-type(2) {
      width: 50%;
      display: flex;
      justify-content: flex-end;
      > img {
        max-width: 140px;
        height: 28px;
        object-fit: contain;
        text-align: end;
        cursor: pointer;
      }
    }
  }

  > div:nth-of-type(2) {
    display: flex;
    flex-direction: row;
    font-size: 16px;

    > div:nth-of-type(1) {
      display: flex;
      flex-direction: row;
      width: 50%;
      align-items: center;
      justify-content: center;

      > div {
        width: 60%;
      }

      > span {
        width: 40%;
        color: #FF0000;
        text-align: end;
        font-size: 20px;
      }
    }

    > div:nth-of-type(2) {
      width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detailProduct/detailProduct.vue